import axios from "axios";
import Utils from "./Utils";
import { Loading } from "element-ui";

const areasQuery = async superAreaID => {
  let returnData = [];
  await axios({
    method: "post",
    url: "areas/query",
    headers: {
      "Content-Type": "application/json",
      "PYDDot-Client-Type": "Web_Admin",
      "PYDDot-Org-ID": Utils.userInfo.orgID,
      "X-Ca-Timestamp": new Date().getTime() / 1000,
      Authorization: Utils.userInfo.token
    },
    data: {
      pageIdx: 0,
      pageSize: 100,
      superAreaID: superAreaID,
      orgID: Utils.userInfo.orgID
    }
  })
    .then(value => {
      returnData = value.data.data;
    })
    .catch(() => {});
  return returnData;
};

const lazyLoad = async (node, resolve) => {
  let superAreaID = "";
  if (node.level > 0) {
    superAreaID = node.data.value;
  }
  let list = await areasQuery(superAreaID);
  let resolveData = [];
  if (list) {
    list.forEach(item => {
      resolveData.push({
        value: item.id,
        label: item.name
      });
    });
  }
  if (node.level === 0) {
    resolveData.unshift({
      value: "全部区域",
      label: "全部区域"
    });
  }
  resolve(resolveData);
};

export default {
  data() {
    return {
      pageIdx: 0,
      pageSize: 20,
      itemTotal: 0,

      listData: [],

      areaProps: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: lazyLoad
      },
      areaIDSelect: ["全部区域"],
      houseNameRegex: "",

      queryData: {},

      queryUrl: "",

      queryMethods: ""
    };
  },

  methods: {
    areasQuery: areasQuery,

    getHeaders() {
      return {
        "Content-Type": "application/json",
        "PYDDot-Client-Type": "Web_Admin",
        "PYDDot-Org-ID": Utils.userInfo.orgID,
        "X-Ca-Timestamp": parseInt(new Date().getTime() / 1000),
        Authorization: Utils.userInfo.token
      };
    },

    numFormat(num) {
      if (num && num !== 0) {
        num = num.toFixed(2);
      }
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },

    meterPricing(num) { // 水电费保留4位小数
      if (num && num !== 0) {
        num = num.toFixed(4);
      }
      return num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
    },

    async queryList() {
      let list = [];

      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      await axios({
        method: this.queryMethods,
        url: this.queryUrl,
        headers: this.getHeaders(),
        data: this.queryData
      })
        .then(value => {
          this.listData = [];
          this.itemTotal = value.data.total;
          list = value.data.data;
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
      return list;
    }
  }
};
